<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page" *ngIf="!contentReady" [attr.dir]="classToggled ? 'rtl' : 'ltr'">
  <div class="bb-page-shell">

    <header class="bb-page-header">
      <div class="bb-page-title-block">
        <span class="bb-eyebrow">{{ "welcome" | transloco }}</span>
        <h2 class="bb-page-title">
          {{ "welcome" | transloco }} :
          <span>{{ userfirstname }}</span>
        </h2>
      </div>

      <div class="bb-header-actions">
        <a routerLink="/change-password" class="bb-btn bb-btn-primary">
          {{ "Change Password" | transloco }}
        </a>
      </div>
    </header>

    <div class="bb-card bb-p-20">
      <div class="bb-flex bb-items-center bb-justify-between bb-wrap bb-gap-20 bb-mb-20">

        <div class="bb-flex bb-items-center bb-gap-16 bb-wrap">
          <div class="bb-product-img-box">
            <img [src]="getAvatarSrc()" (error)="onImageError($event)" [alt]="'Profile Image' | transloco" />
          </div>

          <div class="bb-text-stack">
            <h3 class="bb-text-navy bb-font-bold bb-m-0">
              {{ "welcome" | transloco }} :
              <span>{{ userfirstname }}</span>
            </h3>

            <p class="bb-page-subtitle bb-m-0">
              {{ "username" | transloco }}: {{ userName }}
            </p>
          </div>
        </div>

      </div>

      <div class="bb-form-grid">

        <div class="bb-card bb-p-16">
          <span class="bb-label">{{ "username" | transloco }}</span>
          <p class="bb-m-0 bb-font-bold bb-text-navy">{{ userName }}</p>
        </div>

        <div class="bb-card bb-p-16">
          <span class="bb-label">{{ "phone" | transloco }}</span>
          <p class="bb-m-0 bb-font-bold bb-text-navy">{{ userPhone }}</p>
        </div>

        <div class="bb-card bb-p-16" *ngIf="userInstgram">
          <span class="bb-label">{{ "instagram" | transloco }}</span>
          <a [href]="userInstgram" target="_blank" rel="noopener" class="bb-link-action">
            <i class="fa-brands fa-instagram"></i>
            {{ "instagram" | transloco }}
          </a>
        </div>

        <div class="bb-card bb-p-16" *ngIf="userFacebook">
          <span class="bb-label">{{ "facebook" | transloco }}</span>
          <a [href]="userFacebook" target="_blank" rel="noopener" class="bb-link-action">
            <i class="fa-brands fa-facebook"></i>
            {{ "facebook" | transloco }}
          </a>
        </div>

        <div class="bb-card bb-p-16" *ngIf="userTiktok">
          <span class="bb-label">{{ "tiktok" | transloco }}</span>
          <a [href]="userTiktok" target="_blank" rel="noopener" class="bb-link-action">
            <i class="fa-brands fa-tiktok"></i>
            {{ "tiktok" | transloco }}
          </a>
        </div>



      </div>
    </div>

  </div>
</section>